import { Consultant } from './../../../models/Consultant.model';
import { ResponsibleFinancial } from './../../../models/project/ResponsibleFinancial.model';
import { CompanyGroupsFinancial } from './../../../models/project/CompanyGroupsFinancial.model';
import { CompanyFinancial } from './../../../models/project/CompanyFinancial.model';
import { CommonHelper } from './../../../shared/helpers/CommonHelper';
import { ToastsManager } from 'ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProjectFinancial } from './../../../models/project/ProjectFinancial.model';
import { TeamGroups } from './../../../models/teamGroups.model';
import { ProjectFinancialService } from './../../../services/projectFinancial.service';
import { Component, OnInit } from '@angular/core';
import { Project } from '../../../models/Project.model';
import { AwsService } from '../../../services/aws.service';
import { CompaniesService } from '../../../services/companies.service';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { GUARDS } from '../../../shared/auth/Roles';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { ChangeDetectorRef, AfterContentChecked} from '@angular/core';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { IDropDown } from '../../../models/project/interface/DropDown.interface';
import { DropDownList } from '../../../models/DropDownList.model';
import { filterSelectByArrays } from "../../../shared/helpers/filter-select-items";

@Component({
  selector: 'app-project-edit',
  templateUrl: './project-edit.component.html',
  styleUrls: ['./project-edit.component.css']
})
export class ProjectEditComponent implements OnInit {
    editProjectCheck: boolean = false;
    loading: boolean = false;
    active: boolean = true;
    projectForm: FormGroup;
    fileList;
    selectedFiles:FileList;
    id;
    currentStep = '';
    downloadUrl:string = '';
    dropDownTeamGroups: any;
    consultantGroup: any;
    teamGroups: TeamGroups[] = new Array<TeamGroups>();
    commonHelper: CommonHelper = new CommonHelper();
    project: ProjectFinancial = new ProjectFinancial();
    companies: CompanyFinancial[] = new Array<CompanyFinancial>();
    responsibles: ResponsibleFinancial[] = new Array<ResponsibleFinancial>();
    companyGroups: CompanyGroupsFinancial[] = new Array<CompanyGroupsFinancial>();
    projectsHashTrack: Project[] = new Array<Project>();
    projectStatus: ProjectFinancial[] = new Array<ProjectFinancial>();
    consultantsLoad: Consultant[] = new Array<Consultant>();
    dropDownListStatus: DropDownList[] = new Array<DropDownList>();
    selectedStatusItem: DropDownList[] = new Array<DropDownList>();
    showCustomerDate: Boolean = false;
    canSave: Boolean = true;
    allowedRoles = [GUARDS.MANAGER, GUARDS.GOVERNANCE, GUARDS.FINANCES, GUARDS.DP, GUARDS.JUDICIARY];
    user;
    isJudiciaryUser: Boolean = false;
    projectBeingDeactivated: ProjectFinancial = new ProjectFinancial();
    datePickerOptions = this.commonHelper.getDatePickerOptions();
    dropDownClient: any;
    dropDownProjectshash: any;
    dropDownStatusSettings = {};
    dropDownResponsable: any;
    dropDownConsultant: any;
    dropDownGroup: any;
    excellenceCenters: ExcellenceCenter[] = [];
    dropDownExcellenceCenters: IDropDown;
    consultantsListAux: {id: string, itemName: string}[] = [];

  constructor(
    private projectFinancialService: ProjectFinancialService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastsManager,
    private awsService:AwsService,
    private localStorage: LocalStorage,
    private companiesService:CompaniesService,
    private cdref: ChangeDetectorRef,
    private excellenceCenterService: ExcellenceCentersService,
    private errorHandler: ErrorHandlerProvider
  ) { }

  async ngOnInit() {
    this.loading = true;

    this.checkPermissions();
    this.checkUserJudiciary()

    this.projectForm = this.formBuilder.group({
        name: [null, Validators.required]
    });

    var idProject= this.route.snapshot.params['id'];

    this.project = await this.projectFinancialService.getById(idProject);
    this.sortConsultant();
    this.id = this.route.snapshot.params['id'];

    await Promise.all([
        this.populateCompanyGroups(),
        this.populateResponsables(),
        this.populateProjectsHashTrack(idProject),
        this.populateConsultants(),
        this.populateTeamGroups(),
        this.populateExcellenceCenters(),
    ]);
    await this.getS3Files();
    if(this.fileList.length > 0)
      this.download(this.fileList[0].Key);
    if(this.project.company._id)
      this.checkForExternalReference();

    this.currentStep = 'basic';
    this.closeLoad();
  }

  ngAfterViewChecked() {
    this.cdref.detectChanges();
  }

  checkPermissions() {
    this.user = this.localStorage.retrieve('user');
    if(!this.allowedRoles.includes(this.user.permission)) {
        this.canSave = false;
    }
  }

  async populateExcellenceCenters() {
    const excellenceCenters = await this.excellenceCenterService.getAll();
    this.excellenceCenters = excellenceCenters.filter((c: ExcellenceCenter) => Number(c.type) == 1);
    this.dropDownExcellenceCenters = this.projectFinancialService.createPropertyObjDropDown(this.excellenceCenters, false, 'Centros', 'centros');
    if (!!this.project.excellenceCenters.length) {
        this.dropDownExcellenceCenters.selectedItems = this.project.excellenceCenters.map((ec: {_id: string, name: string}) => {
            return {
                id: ec._id,
                itemName: ec.name
            } as DropDownList
        })
    }
}

  async populateCompanyGroups() {
    const res = await this.projectFinancialService.getAllCompanyGroups();
    this.companyGroups = res;
    this.dropDownGroup = await this.projectFinancialService.createPropertyObjDropDown(this.companyGroups, true, "Grupos", "grupos");
    if(this.dropDownGroup.dropDownList && this.dropDownGroup.dropDownList.length > 0){
      let companyGroup = this.dropDownGroup.dropDownList.find(fnd => fnd.id == this.project.companyGroup._id);
      if(companyGroup)
        this.dropDownGroup.selectedItems.push(companyGroup);
    }
    await this.populateCompanies();
  }

  async populateCompanies() {
    let hasGroup = (this.dropDownGroup && this.dropDownGroup.selectedItems.length > 0) ?
        this.dropDownGroup.selectedItems[0].id : false;
    const res = await this.projectFinancialService.getAllCompany(hasGroup);
    this.companies = res;
    this.dropDownClient = await this.projectFinancialService.createPropertyObjDropDown(this.companies, true, "Cliente", "clientes",['group'],'group');
    if(this.dropDownClient.dropDownList && this.dropDownClient.dropDownList.length > 0){
        let company = this.dropDownClient.dropDownList.find(fnd => fnd.id == this.project.company._id);
        if(company)
            this.dropDownClient.selectedItems.push(company);
    }
    this.dropDownClient.dropDownList.forEach(item => item.group =  this.commonHelper.transcriptDivisionGroup(item.group));
    this.closeLoad();
  }

  async populateResponsables() {
    const res = await this.projectFinancialService.getAllResponsable()
    this.responsibles = res;
    this.dropDownResponsable = await this.projectFinancialService.createPropertyObjDropDown(this.responsibles, true, "Responsável", "responsáveis");
    this.dropDownResponsable.selectedItems.push(
        this.dropDownResponsable.dropDownList.find(fnd => fnd.id == this.project.userResponsable._id)
    );
    this.closeLoad();
  }

  async getS3Files(){
    this.fileList = await this.awsService.getFiles(this.project._id);
  };

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  async deleteFile(name){
    await this.awsService.deleteFile(name);
    await this.getS3Files();
  }

   async upload(id) {
     try {
        let length = this.selectedFiles.length;
        for(let i=0; i<length; i++){
          const file = this.selectedFiles.item(i);
            await this.awsService.uploadfile(file,id);
        }

        await this.getS3Files();
        this.onChange();
     } catch (error) {
       console.log(error);
     }
  }

    async populateProjectsHashTrack(id) {
        if (id == '') {
            const res = await this.projectFinancialService.getAllProject();
            this.projectsHashTrack = res;
            this.populateDropHash();
        } else {
            const res = await this.projectFinancialService.getAllProjectEdit(id);
            this.projectsHashTrack = res;
            this.populateDropHash();
        }
    }

    async populateDropHash() {
        this.dropDownProjectshash = await this.projectFinancialService.createPropertyObjDropDown(this.projectsHashTrack, false, "Projetos", "projetos");
        var projetos = await this.dropDownProjectshash.dropDownList.filter(flt => this.project.hashTrack.find(fnd => fnd._id == flt.id) != null);
        projetos.forEach(element => {
            this.dropDownProjectshash.selectedItems.push(element);
        });
        this.closeLoad();
    }

    async populateConsultants() {
      const res = await this.projectFinancialService.getAllConsultants();
      this.consultantsLoad = res;
      this.dropDownConsultant = await this.projectFinancialService.createPropertyObjDropDown(this.consultantsLoad, false, "Consultores", "consultores");
      this.consultantsListAux = [...this.dropDownConsultant.dropDownList];
      this.closeLoad();
    }

    async populateTeamGroups() {
      this.teamGroups = await this.projectFinancialService.getAllTeamGroups();
      this.dropDownTeamGroups = await this.projectFinancialService.createPropertyObjDropDown(this.teamGroups, false, "Grupos de Times", "Grupos de Times");
      let teamGroupOfProject = await this.dropDownTeamGroups.dropDownList.filter(flt => this.project.teamGroups.find(fnd => fnd._id == flt.id) != null);
      teamGroupOfProject.forEach(element => {
        this.dropDownTeamGroups.selectedItems.push(element);
      });

      this.closeLoad();
    }

    closeLoad() {
        if (this.responsibles.length > 0 && this.projectsHashTrack.length > 0 && this.consultantsLoad.length > 0) {
            this.loading = false;
            this.onChange();
        }
    }

  onChange() {
      if (!this.loading) {
        if (this.dropDownResponsable.selectedItems.length > 0
            && this.dropDownClient.selectedItems.length > 0
            && this.projectForm.valid) {
                this.editProjectCheck = true;
            } else {
                this.editProjectCheck = false;
            }
        }
  }

  checkUserJudiciary() {
    this.user = this.localStorage.retrieve('user');
    if(this.user.permission == GUARDS.JUDICIARY)
      this.isJudiciaryUser = true;
  }

  clearCustomer(){
      this.dropDownClient.selectedItems = [];
      this.populateCompanies();
  }

  async edit() {
    if(this.dropDownClient.selectedItems.length > 0)
      this.project.company = this.companies.find(fnd => fnd._id == this.dropDownClient.selectedItems[0].id);

    this.project.companyGroup = this.companyGroups.find(fnd => fnd._id == this.dropDownGroup.selectedItems[0].id);
    this.project.userResponsable = this.responsibles.find(fnd => fnd._id == this.dropDownResponsable.selectedItems[0].id);
    this.project.hashTrack = this.projectsHashTrack
          .filter(flt => this.dropDownProjectshash.selectedItems.find(fnd => fnd.id == flt._id) != null);
    if(this.dropDownTeamGroups.selectedItems.length > 0)
        this.project.teamGroups = this.dropDownTeamGroups.selectedItems.map(teamGroup => ({ _id: teamGroup.id, name: teamGroup.itemName }));

    if (!this.dropDownExcellenceCenters.selectedItems.length) {
        this.toastr.warning('Selecione um ou mais Centros de Excelência para prosseguir com a criação do Projeto', 'Projeto');
        return;
    };

    try {
      if(this.project.name.length > 30)
        return this.toastr.warning('O nome do projeto é longo demais, permitido apenas 30 caracteres!');

      this.loading = true;
      let response = await this.projectFinancialService.update(this.project);
      if(response._id){
        this.toastr.success('Projeto alterado com sucesso!');
        this.router.navigate(['/projects']);
      } else {
        this.errorHandler.interceptError(response, 'Projeto');
      }
      this.loading = false;
    } catch(err) {
        this.loading = false;
        this.errorHandler.interceptError(err, 'Projeto');
        this.router.navigate(['/projects']);
    }
  }

  OnCancel() {
    this.router.navigate(['/projects']);
  }

  verifyValidTouched(fieldName) {
    return !this.projectForm.get(fieldName).valid && this.projectForm.get(fieldName).touched;
  }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }

  async download(name){
    this.downloadUrl = await this.awsService.download(name);
    // var a = document.createElement("a");
    // let dataURI = "data:" + file.ContentType +
    //     ";base64," + file.Body;
    // a.href = dataURI;
    // a['download'] = name.split("/")[1];
    // var e = document.createEvent("MouseEvents");
    // // Use of deprecated function to satisfy TypeScript.
    // e.initMouseEvent("click", true, false,
    //     document.defaultView, 0, 0, 0, 0, 0,
    //     false, false, false, false, 0, null);
    // a.dispatchEvent(e);
  }

  sortConsultant() {
    this.project.consultants.sort((a, b) => {
        if(a.name > b.name) return 1;
        if(a.name < b.name) return -1;
        return 0;
    })
  }

  addItem() {
    if(this.dropDownConsultant.selectedItems.length > 0 ) {
      const selectedConsultant = this.dropDownConsultant.selectedItems[0];
      const consultant = new Consultant();
      consultant._id = selectedConsultant.id;
      consultant.name = selectedConsultant.itemName;

      this.addConsultant(consultant);
      this.toastr.info(`O consultor "${consultant.name}" foi adicionado ao projeto!`, "Novo consultor")

      this.dropDownConsultant.selectedItems = [];
    }
  }

  addConsultant(consultant: Consultant) {
    let existsConsultant =  this.project.consultants.findIndex(item => item._id == consultant._id);
    if( existsConsultant === -1 ){
      let newConsultant = this.consultantsLoad.find(c => c._id == consultant._id);
      if(newConsultant) {
        consultant.fcEmail = newConsultant.fcEmail;
        consultant.sapCardCode = newConsultant.sapCardCode;
        consultant.hashTrackId = newConsultant.hashTrackId;
        this.project.consultants.push(consultant);
        this.refreshConsultantSelect();
      }
    }

    this.sortConsultant();
  }

  addItemGroup() {
    if(this.dropDownTeamGroups.selectedItems.length > 0) {

      let teamGroupsConsultants = [];
      const teamGroupsIds = this.dropDownTeamGroups.selectedItems.map(t => t.id);
      teamGroupsIds.forEach(tgId => {
        const teamGroup = this.teamGroups.find(t => t._id === tgId);
        teamGroupsConsultants = [...teamGroupsConsultants, ...teamGroup.consultants];
      });

      teamGroupsConsultants.forEach(c => {
        const consultant = new Consultant();
        consultant._id = c._id;
        consultant.name = c.name;

        this.addConsultant(consultant);
      });
      const [teamGroupName] = this.dropDownTeamGroups.selectedItems;
      this.toastr.info(`O Grupo "${teamGroupName.itemName}" foi adicionado no projeto!`, "Novo consultor")
    }
  }

  refreshConsultantSelect = () => {
    const teamGroupIds = this.project.consultants.map((cons) => cons._id);
    this.dropDownConsultant.dropDownList = filterSelectByArrays(this.consultantsListAux, teamGroupIds);
  }

  removeItem(i) {
    const consultantName =  this.project.consultants[i].name || "";
    let consultant = this.project.consultants[i];
    let indexConsulntant = this.dropDownConsultant.selectedItems.findIndex((consultantDeopDown) => consultantDeopDown.id == consultant._id);
    if(indexConsulntant != -1)
      this.dropDownConsultant.selectedItems.splice(indexConsulntant, 1);

    this.project.consultants.splice(i, 1);
    this.refreshConsultantSelect();
    this.toastr.info(`O consultor "${consultantName}" foi removido do projeto!`);
  }

  async checkForExternalReference(){
    let _id = this.project.company._id.toString()
    let company = await this.companiesService.getById(_id);
    if(company){
      if(!company.externalReference){
        this.toastr.onClickToast()
                    .subscribe( toast => {
                      this.router.navigate([`/companies/companies-edit/${_id}`]);
                      this.toastr.dismissToast(toast);
                    });
                    this.toastr.error(`O cliente selecionado não possui vínculo com um cliente Hashtrack. Para vincular, clique aqui!`,'Cliente não mapeado!',{
                      toastLife:10000,
                      showCloseButton: true
                    });
      }
    }
  }

  onCenterChange() {
    if (this.dropDownExcellenceCenters.selectedItems.length) {
      const centers = this.dropDownExcellenceCenters.selectedItems.map((center: DropDownList) => {
        return {
          _id: center.id,
          name: center.itemName
        } as ExcellenceCenter
      });
      this.project.excellenceCenters = [...centers];
        return;
      }
      this.project.excellenceCenters = new Array<ExcellenceCenter>();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/projects/project-edit/project-edit.component.ts